import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Testimonials are disabled until we have real, attributable customer quotes.
// Do NOT ship fabricated testimonials or invented statistics — it is misleading
// and a consumer-protection risk. To re-enable, populate `testimonials` with
// genuine, approved entries: { name, position, comment, imgSrc }.
const testimonials = [];

const sliderSettings = {
  centerMode: true,
  dots: false,
  slidesToShow: 3,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
};

export default function Testimonials() {
  if (!testimonials.length) {
    return null;
  }

  return (
    <section className="testimonials">
      <Slider {...sliderSettings}>
        {testimonials.map((testimonial, index) => (
          <div key={index} className="slider-item">
            <div className="columns">
              <div className="column is-3">
                <div className="profile">
                  <img src={testimonial.imgSrc} alt={`${testimonial.name} profile`} className="client-logo" />
                  <div className="name">{testimonial.name}</div>
                  <div className="position">{testimonial.position}</div>
                </div>
              </div>
              <div className="column is-9">
                <div className="comment">"{testimonial.comment}"</div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}
